export default __webpack_public_path__ + "static/media/about_3.2cf317d7.png";